import { computed, defineComponent, ref, toRefs, watch } from '@vue/composition-api';
export default defineComponent({
    name: 'DpConfirmTextDialog',
    props: {
        title: { type: String, default: '' },
        type: { type: String, default: '' },
        subtitle: { type: String, default: '' },
        visible: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        confirmText: { type: String, default: 'Confirm' },
    },
    emits: ['cancel', 'confirm'],
    setup(props) {
        const { visible } = toRefs(props);
        const isVisible = ref(props.visible);
        const deleteInput = ref('');
        const displayTitle = computed(() => {
            if (props.title)
                return props.title;
            switch (props.type) {
                case 'delete': return 'Confirm deletion';
                case 'confirm': return 'Confirm';
                default: return 'Confirm';
            }
        });
        const buttonType = computed(() => {
            switch (props.type) {
                case 'delete': return 'error';
                case 'confirm': return 'primary';
                default: return null;
            }
        });
        const confirmButtonText = computed(() => {
            switch (props.type) {
                case 'delete': return 'Delete';
                case 'confirm': return 'Confirm';
                default: return 'Nothing';
            }
        });
        const validDelete = computed(() => props.confirmText === deleteInput.value);
        watch(visible, (newValue) => {
            if (newValue === true)
                deleteInput.value = ''; // clear on reload
            isVisible.value = newValue;
        });
        return {
            // ref
            isVisible,
            deleteInput,
            // compute
            displayTitle,
            buttonType,
            confirmButtonText,
            validDelete,
        };
    },
});
